import { render, staticRenderFns } from "./BasedAnotherStandardMethod.vue?vue&type=template&id=05590e9f&scoped=true&"
import script from "./BasedAnotherStandardMethod.vue?vue&type=script&lang=js&"
export * from "./BasedAnotherStandardMethod.vue?vue&type=script&lang=js&"
import style0 from "./BasedAnotherStandardMethod.vue?vue&type=style&index=0&id=05590e9f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05590e9f",
  null
  
)

export default component.exports